<template>
  <div class="chat-answer">
    <div v-if="message" class="chat-answer__wrapper">
      <span class="chat-answer__name">{{ message.sender.author }}</span>
      <div class="chat-answer__body">
        <img v-if="replaceSticker(message.msg)" :src="replaceSticker(message.msg)"/>
        <nl2br v-else tag="span" :text="truncateQuote(message.msg)"/>
      </div>
      <div @click="clearQuote" class="chat-answer__cancel">
        <v-icon color="grey">
          mdi-close
        </v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import {cleanMessage, replaceSticker} from "@/helpers";

export default {
    name: "Quote",
    props: ['message'],
    methods: {
      clearQuote() {
        this.$emit('update-quote', null)
      },
      truncateQuote(msg) {
        msg = cleanMessage(msg);
        if (msg.length > 75 ) {
          msg = msg.substring(0,75)+".."
        }
        return msg
      },
      replaceSticker(msg) {
        const wsUrl = this.$settings.websocket || this.$store.getters.getServer
        const host = wsUrl.replace('ws://', 'http://').replace('wss://', 'https://')
        const src = new URL('/static/stickers/shark/', host).href
        return replaceSticker(msg, src);
      }
    }
  }
</script>
